<template>
  <div class="form-course-item">
    <div class="form-item-title">{{ column.label }}:</div>
    <van-rate
      v-model="value"
      @change="change"
      :size="25"
      :count="column.max"
      color="#ffd21e"
      void-icon="star"
      void-color="#eee"
    />
    <span class="rate-text" v-if="column.showText && startShowRate">{{ column.texts[index] }}</span>
  </div>
</template>

<script>
export default {
  props: ['column'],
  data() {
    return {
      value: 0,
      index: 0,
      startShowRate: false
    }
  },
  methods: {
    change(value) {
      this.startShowRate = true
      this.index = value - 1
      const obj = {[this.column.prop]: value}
      this.$store.commit('setReport', obj)
    }
  }
}
</script>

<style></style>
